import { Form } from 'vform';
import { HasError, AlertError } from 'vform/src/components/bootstrap5';
//import { VueCollapse } from 'vue2-collapse';
//import { pagination } from 'laravel-vue-pagination';
window.Form = Form; //TODO: change this to proper variable usage, i.e: this.$form

import InlineSvg from 'vue-inline-svg';
//app.component('inline-svg', InlineSvg);
//app.component('slide-up-down', SlideUpDown);

import { debounce } from 'vue-debounce'

export default {
  install: (app, options) => {
        [
            Form //v-form causes the warning "Do not use built-in or reserved HTML elements as component id: g"
            ,HasError
            ,AlertError
            ,InlineSvg
//            ,VueCollapse
        ].forEach(Component => {
            app.component(Component.name, Component);
        });
  }
}